import { render, staticRenderFns } from "./Telepathology.vue?vue&type=template&id=53eff842&"
import script from "./Telepathology.vue?vue&type=script&lang=js&"
export * from "./Telepathology.vue?vue&type=script&lang=js&"
import style0 from "./Telepathology.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports